import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    currentOutletId: String
  }

  switch(event) {
    const newOutletId = event.detail?.value !== undefined ? event.detail.value : event.target.value
    if (!newOutletId || newOutletId.toString() === this.currentOutletIdValue?.toString()) return

    const currentPath = window.location.pathname
    // Replace /outlets/:id with /outlets/:newOutletId
    const newPath = currentPath.replace(/\/outlets\/\d+/, `/outlets/${newOutletId}`)
    const searchParams = new URLSearchParams(window.location.search)

    // Remove any outlet_id from query params so it doesn't duplicate path
    searchParams.delete("filter[outlet_id]")
    searchParams.delete("outlet_id")

    const queryString = searchParams.toString()
    const targetUrl = queryString ? `${newPath}?${queryString}` : newPath

    if (window.Turbo) {
      window.Turbo.visit(targetUrl)
    } else {
      window.location.href = targetUrl
    }
  }

  filter(event) {
    const form = this.element.closest("form") || (this.element.tagName === "FORM" ? this.element : null)
    form?.requestSubmit()
  }
}
